import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Poppins Regular';
  }
  body {
    background-color: ${({ theme }) => theme.colors.background};
    margin: 0;
    display: flex;
    flex-direction: column;   
    height: 100%;
    p {
      margin-bottom: 0;
    }
    img {
      height: auto;
      max-width: 100%;
    }
    button {
      &:focus {
        box-shadow: none !important;
      }
    }
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type="number"] {
      -moz-appearance: textfield;
    }
    .lds-dual-ring {
      display: inline-block;
      width: 28px;
      height: 28px;
    }
    .lds-dual-ring:after {
      content: " ";
      display: block;
      width: 28px;
      height: 28px;
      margin-top: 8px;
      border-radius: 50%;
      border: 6px solid #fff;
      border-color: #fff transparent #fff transparent;
      animation: lds-dual-ring 1.2s linear infinite;
    }
    @keyframes lds-dual-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
  .hidden{
    display : none;
  }
`;

export default GlobalStyle;
